import { Avatar, Box, Button, Checkbox, CircularProgress, Collapse, Dialog, FormControl, FormControlLabel, IconButton, Menu, MenuItem, Radio, RadioGroup, Select, Step, StepLabel, Stepper, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Tooltip, Typography, useTheme } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import React, { useCallback, useRef, useState } from 'react'
import { Form, Formik, ErrorMessage, Field } from 'formik'
import { ContentCopy, Delete, } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { observer } from 'mobx-react'
import * as Yup from 'yup'
import dayjs from 'dayjs'

import { ACHARYA_EMAIL_PATTERN, debounce, formatDate, Icons } from '../../utils/utilities'
import VisuallyHiddenInput from '../common/VisuallyHiddenInput'
import DataLoadingSpinner from '../common/DataLoadingSpinner'
import { useMeetingStore } from '../../store/meeting.store'
import spreadSheetImg from '../../assets/spreadsheet.svg'
import { useUserStore } from '../../store/user.store'
import CustomSwitch from '../common/CustomSwitch'
import TableHeader from '../common/TableHeader'
import readXlsxFile from 'read-excel-file'
import api from '../../service/api'
import MeetingDetailsCopyDialog from './MeetingDetailsCopyDialog'

const userTableColumns = [
    { name: "Sl. No.", width: "80px", minWidth: "80px", align: "center", styles: { padding: "10px 5px" } },
    { name: "Host", width: "80px", minWidth: "80px", align: "center", styles: { padding: "10px 5px" } },
    { name: "Name", minWidth: "120px", align: "left", styles: { padding: "10px 5px" } },
    { name: "E-mail", minWidth: "120px", align: "left", styles: { padding: "10px 5px" } },
    { name: "", align: "right", styles: { padding: "10px 5px" } },
]
const steps = ['Fill in Meeting Details', 'Configure Access and Save']

const meetingTypes = [
    // { label: "Class", value: "class", description: "Only hosts video, audio and presentation will be shown to participants, by default all microphone, camera and screen sharing options will be disabled. meeting host can give access to these features to a specific users inside the meeting if necessary." },
    { label: "Webinar", value: "webinar", description: "Hosts can publish video, audio and presentation, these feeds will be shown to participants, By default all microphone, camera and screen sharing options will be disabled for participants. meeting host can give access to these features to a specific users inside the webinar if necessary." },
    { label: "General Meetings", value: "discussion", description: "By default all the particiants cards are displayed to all participants, the microphone, camera and screen sharing options will enabled based on meeting hosts preference. For small attendings" },
    // { label: "Hybrid Class", value: "hybrid-class", description: "One-side live class streming will be done to students hoping to learn from home. External camera and mic setup is required for the great video and audio quality." },
]

const dummyClass = {
    "subject_id": 873,
    "course_branch_assignment_id": "57,117,118,119",
    "subject_name_short": "DBMS",
    "course_assignment_id": "20,20,20,20",
    "time_table_id": 225997,
    "batch_assignment_id": 1392,
    "subject_assignment_id": 6771,
    "institute_id": 1,
    "current_sem": 1,
    "duration": 55,
    "batch_short_name": "B1",
    "current_year": 1,
    "branch_id": 12,
    "branch_name": "Master of Computer Applications",
    "selected_date": "2026-02-14",
    "sTime": "09:40:00.0000000",
    "course_branch_short_name": "MCA,MCAI,MCADS,MCA CC",
    "empID": "AI00441",
    "program_assignment_id": null,
    "eTime": "10:35:00.0000000",
    "end_time": "10:35 AM",
    "presenter_name": "Sumit Singha Chowdhury",
    "institute_name": "ACHARYA INSTITUTE OF TECHNOLOGY",
    "institute_name_short": "AIT",
    "start_time": "9:40 AM",
    "course_short_name": "MCA,MCA,MCA,MCA",
    "intervals": "9:40 AM - 10:35 AM",
    "section_short_name": "NA",
    "online": false,
    "interval_type_id": 1,
    "section_assignment_id": null
}


const validationSchema = Yup.object().shape( {
    title: Yup.string().required( "Title is a required field." ),
    starts_at: Yup.mixed().required( "Please specify start time." ).test( "VALID_END_TIME", "Please enter a valid meeting start time, Can not be less than current time.", ( val ) => {
        if ( val <= new Date() )
            return false
        return true
    } ),
    ends_at: Yup.mixed().test( "VALID_END_TIME", "Please enter a valid end time", ( val, { parent } ) => {
        if ( val <= parent.starts_at )
            return false
        const diff = ( new Date( val ).getTime() - new Date( parent.starts_at ).getTime() ) / ( 1000 * 60 * 60 )
        if ( diff < 0 )
            return false
        if ( diff > 10 )
            return false
        return true
    } ),
    meeting_settings: Yup.mixed().test( "MISSING_ACCESS_GROUPS_OR_USERS", "Please select atleast one student groups or users to meet with.", ( val, { parent, createError, path } ) => {
        if ( val.access_type === "ANY_ONE_CAN_JOIN" ) return true
        if ( parent.added_users?.length === 0 && parent.selected_student_groups.length === 0 )
            return createError( {
                path: `${path}.access_type`,
                message: "Please select atleast one student groups or users to meet with."
            } )
        return true
    } )

} )

const CreateRoom = observer( ( { fetchMeetings, open, setOpen, defaultType } ) => {

    const [isLoadingAcYearsBatchesAndSectionsData, setIsLoadingAcYearsBatchesAndSectionsData] = useState( false )
    const [isUserOrGroupSelectionCollapsed, setIsUserOrGroupSelectionCollapsed] = useState( false )
    const [academicYearsAnchorEl, setAcademicYearsAnchorEl] = useState( null )
    const [loadingHostDetails, setLoadingHostDetails] = useState( false )
    const [creatingMeeting, setCreatingMeeting] = useState( false )
    const [hostSearchValue, setHostSearchValue] = useState( '' )
    const [userSearchValue, setUserSearchValue] = useState( '' )
    const [activeStep, setActiveStep] = React.useState( 0 )
    const [refreshing, setRefreshing] = useState( false )
    const [isDropping, setIsDropping] = useState( false )
    const [newRoom, setNewRoom] = useState()

    const MeetingStore = useMeetingStore()
    const UserStore = useUserStore()
    const navigate = useNavigate()

    const { palette, border } = useTheme()

    const nameInputRef = useRef()
    const emailInputRef = useRef()


    const initialValues = {
        title: '',
        starts_at: dayjs(),
        ends_at: dayjs().add( 1, 'hour' ),
        hosts: [],
        selected_student_groups: [],
        added_users: [],
        added_users_emails: [],
        batch_groups_selected: 0,
        section_groups_selected: 0,
        selectedAcYear: null,
        meeting_type: defaultType ?? 'webinar',
        meeting_settings: {
            access_type: 'ANY_ONE_CAN_JOIN',
            any_one_can_join_with_pass_key: true,
            enable_chats: true,
            enable_screen_sharing: false,
            enable_microphone: false,
            enable_video_feed: false,
            join_without_host: false,
            enable_reactions: true,
        }
    }

    // STEPPER FUNCTIONS
    const handleNext = () => {
        setActiveStep( ( prevActiveStep ) => prevActiveStep + 1 )
    }

    const handleBack = () => {
        setActiveStep( ( prevActiveStep ) => prevActiveStep - 1 )
    }

    const handleMeetingTypeChange = ( value, setFieldValue ) => {
        try {
            if ( value === 'webinar' ) {
                setFieldValue( 'meeting_settings.enable_microphone', false )
                setFieldValue( 'meeting_settings.enable_video_feed', false )
                setFieldValue( 'meeting_settings.enable_screen_sharing', false )
            }
            setFieldValue( 'meeting_type', value )
        } catch ( err ) {
            console.log( err )
        }
    }

    const handleHostSearchKeyDown = debounce( 'host-search', async ( event, setFieldValue, values ) => {
        try {
            let value = event.target.value?.trim()?.toLowerCase()

            value = value.split( "," ).map( em => em.trim() )
            let emails = value.filter( em => Boolean( em?.match( ACHARYA_EMAIL_PATTERN ) ) )
            emails = emails.filter( em => !values.added_users_emails?.includes( em ) )

            if ( emails.length > 0 ) {
                const { data: { data: usersDetails, all_fetched, missed_emails = [] } } = await api.fetchUserDetailsByEmail( { emails } )
                const usersList = values?.added_users
                usersDetails?.forEach( userDetails => {
                    userDetails.host = false
                } )
                usersList.push( ...usersDetails )
                setFieldValue( 'added_users', usersList )
                setFieldValue( 'added_users_emails', usersList?.map( u => u.user_email ) )
                if ( !all_fetched )
                    toast( "Couldn't find user details for some E-mails..." )
                setUserSearchValue( missed_emails.join( "," ) )
            } else {
                setUserSearchValue( '' )
            }
        } catch ( err ) {
            console.log( err )
        } finally {
            setLoadingHostDetails( false )
        }
    }, 1000 )

    const handleUserAddInputKeyDown = async ( event, values, setFieldValue ) => {
        try {
            if ( event.key === 'Enter' ) {
                event.preventDefault()
                let value = event.target.value || ""
                value = value.split( "," ).map( em => em.trim() )
                let emails = value.filter( em => Boolean( em?.match( ACHARYA_EMAIL_PATTERN ) ) )
                emails = emails.filter( em => !values.added_users_emails?.includes( em ) )

                if ( emails.length > 0 ) {
                    const { data: { data: usersDetails, all_fetched, missed_emails = [] } } = await api.fetchUserDetailsByEmail( { emails } )
                    const usersList = values?.added_users
                    usersDetails?.forEach( userDetails => {
                        userDetails.host = false
                    } )
                    usersList.push( ...usersDetails )
                    setFieldValue( 'added_users', usersList )
                    setFieldValue( 'added_users_emails', usersList?.map( u => u.user_email ) )
                    if ( !all_fetched )
                        toast( "Couldn't find user details for some E-mails..." )
                    setUserSearchValue( missed_emails.join( "," ) )
                } else {
                    setUserSearchValue( '' )
                }
            }
        } catch ( err ) {
            toast( err?.response?.data?.message || "Failed to fetch user details!" )
        }
    }

    const removeAddedUser = ( index, values, setFieldValue ) => {
        const users = values.added_users
        const usersEmail = values.added_users_emails
        users?.splice( index, 1 )
        usersEmail?.splice( index, 1 )
        setFieldValue( 'added_users', users )
        setFieldValue( 'added_users_emails', usersEmail )
    }

    const addNewUser = ( values, setFieldValue ) => {
        const name = nameInputRef.current?.value
        const email = emailInputRef.current?.value?.toLowerCase()
        if ( name && email ) {
            if ( values?.added_users_emails?.includes( email ) )
                return toast( "E-mail has already been added!" )
            const users = values.added_users
            const usersEmail = values.added_users_emails
            const newUser = {}
            newUser.user_name = name
            newUser.user_email = email
            newUser.user_id = email
            users.push( newUser )
            usersEmail.push( email )
            setFieldValue( 'added_users', users )
            setFieldValue( 'added_users_emails', usersEmail )
            nameInputRef.current.value = ""
            emailInputRef.current.value = ""
        }
    }

    const handleUserlistFileDragLeave = ( event ) => {
        setIsDropping( false )
    }

    const handleUserlistFileDrop = ( event, values, setFieldValue ) => {
        event.preventDefault()
        setIsDropping( false )
        handleOnExcelFileSelection( event, values, setFieldValue )
    }

    const handleUserlistFileDragOver = ( event ) => {
        event.preventDefault()
        setIsDropping( true )
    }

    const handleOnExcelFileSelection = async ( event, values, setFieldValue ) => {
        try {
            const file = event.type === "drop" ? event.dataTransfer.files[0] : event.target.files[0]
            if ( file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' )
                return toast( "Please select a Excel(.xlsx) file." )

            const excelData = await readXlsxFile( file )
            const users = [...values.added_users]
            const usersEmail = [...values.added_users_emails]

            const newUsers = []
            const newUsersEmails = []

            for ( const row of excelData ) {
                const [name, email] = row
                if ( !name || !email || !email?.match( ACHARYA_EMAIL_PATTERN ) )
                    continue
                if ( usersEmail?.includes( email ) )
                    continue

                const newUser = {}
                newUser.user_name = name
                newUser.user_email = email
                newUser.user_id = email
                newUsers.push( newUser )
                newUsersEmails.push( email )
            }
            if ( newUsers.length > 0 ) {
                users.push( ...newUsers )
                usersEmail.push( ...newUsersEmails )
                setFieldValue( 'added_users', users )
                setFieldValue( 'added_users_emails', usersEmail )
            }
        } catch ( err ) {
            console.log( err )
        } finally {
            event.target.value = ''
        }
    }

    const handleUserAddInputChange = ( event ) => {
        setUserSearchValue( event.target.value )
    }

    const handleAccessTypeChange = async ( accessType, setFieldValue ) => {
        await setFieldValue( 'meeting_settings.access_type', accessType )
        await setFieldValue( 'meeting_settings.any_one_can_join_with_pass_key', accessType === 'ANY_ONE_CAN_JOIN' )
        if ( accessType === "SPECIFIED_GROUPS_AND_USERS" ) {
            setIsUserOrGroupSelectionCollapsed( true )
            if ( UserStore.getErrorsStatuses?.academicYearsAndBatches === true || UserStore.getErrorsStatuses?.academicYearsAndBatches === undefined ) {
                setIsLoadingAcYearsBatchesAndSectionsData( true )
                await UserStore.fetchUsersAllBatchesAndSectionList()
                setIsLoadingAcYearsBatchesAndSectionsData( false )
            }
            if ( !UserStore.getErrorsStatuses?.academicYearsAndBatches ) {
                setFieldValue( 'selectedAcYear', UserStore.getUserAcademicYears[0].ac_year_id )
            }
        }
    }

    const toggleStudentGroupSelection = ( group, setFieldValue, prevValues ) => {
        const newValues = [...prevValues.selected_student_groups]
        const groupIndex = newValues.findIndex( g => g.id === group.id )

        if ( groupIndex >= 0 ) {
            newValues.splice( groupIndex, 1 )
            if ( group.entity === 'batch' )
                setFieldValue( 'batch_groups_selected', prevValues.batch_groups_selected - 1 )
            else
                setFieldValue( 'section_groups_selected', prevValues.section_groups_selected - 1 )
        } else {
            newValues.push( group )
            if ( group.entity === 'batch' )
                setFieldValue( 'batch_groups_selected', prevValues.batch_groups_selected + 1 )
            else
                setFieldValue( 'section_groups_selected', prevValues.section_groups_selected + 1 )
        }
        setFieldValue( 'selected_student_groups', newValues )


    }

    const toggleHostAccess = ( user, values, setFieldValue ) => {
        try {
            const newUsersList = [...values.added_users]
            const newHostsList = [...values.hosts]

            const userDetails = newUsersList.find( u => u.user_id === user.user_id )
            const isHost = !Boolean( userDetails.host )
            userDetails.host = isHost
            if ( isHost ) {
                newHostsList.push( user )
            } else {
                const hostIndex = newHostsList.findIndex( host => host.user_id === user.user_id )
                if ( hostIndex >= 0 )
                    newHostsList.splice( hostIndex, 1 )

            }
            setFieldValue( 'added_users', newUsersList )
            setFieldValue( 'hosts', newHostsList )
        } catch ( err ) {
            console.log( err )
        }
    }

    const validateFirstStep = async ( validateForm, setFieldTouched ) => {
        const errors = await validateForm()

        const firstStepRequiredFields = ['title', 'starts_at', 'ends_at']
        let noErrors = true
        for ( const field of firstStepRequiredFields ) {
            if ( errors[field] ) {
                noErrors = false
                setFieldTouched( field, true, true )
            }
        }
        if ( noErrors )
            handleNext()
    }


    const handleClose = ( resetForm ) => {
        setNewRoom( null )
        setOpen( false )
        if ( resetForm && typeof resetForm === 'function' )
            resetForm()
        setActiveStep( 0 )
    }

    const createOnlineMeeting = async ( values, { resetForm } ) => {
        try {
            setCreatingMeeting( true )
            if ( values.meeting_type === "hybrid-class" ) {
                values.time_table_id = dummyClass.time_table_id
                values.time_table_class_details = dummyClass
            }
            const { data: { data: newRoom } } = await api.onlineMeetings.createMeeting( values )
            setNewRoom( newRoom )
            fetchMeetings()
        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data?.message || "Failed to create new meeting. Please try again." )
        } finally {
            setCreatingMeeting( false )
        }
    }


    return (
        <Dialog slotProps={{ paper: { sx: { maxWidth: newRoom ? "auto" : "md", width: newRoom ? "auto" : "90%", } } }} open={open}  >

            {!newRoom &&

                <Formik validationSchema={validationSchema} onSubmit={createOnlineMeeting} initialValues={initialValues} >

                    {( { values, setFieldValue, validateForm, errors, setFieldTouched, resetForm, touched } ) => {
                        return (
                            <Box>
                                <Box position="sticky" top="0" zIndex={20} bgcolor={palette.background.paper} borderBottom={border[1]} display="flex" alignItems="center" justifyContent="space-between" gap="20px" padding="10px 20px">
                                    <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">Create new {values.meeting_type}</Typography>
                                    <IconButton onClick={() => handleClose( resetForm )} >{Icons.default.CloseIcon}</IconButton>
                                </Box>
                                <Form>
                                    <Box padding="20px">
                                        <Stepper activeStep={activeStep}>
                                            {steps.map( ( label, index ) => {
                                                const lableWithMeetingType = label.replace( "Meeting", values.meeting_type === 'webinar' ? "Webinar" : "Meeting" )
                                                return (
                                                    <Step key={label} >
                                                        <StepLabel >{lableWithMeetingType}</StepLabel>
                                                    </Step>
                                                )
                                            } )}
                                        </Stepper>
                                    </Box>
                                    {/* FIRST STEP */}
                                    {activeStep === 0 && <Box padding="20px">
                                        <FormControl fullWidth >
                                            <label htmlFor="title"><Typography variant='subtitle2' >{values.meeting_type === 'webinar' ? "Webinar" : "Meeting"} title *</Typography></label>
                                            <Typography marginTop="-5px" fontSize="12px" component="em">Enter a name that is easily identify this particular {values.meeting_type}.</Typography>
                                            <Field as={TextField} name="title" placeholder='Title' id="title" size='small' />
                                        </FormControl>
                                        <FormControl fullWidth margin='normal' >
                                            <label htmlFor='starts_at' > <Typography gutterBottom variant="subtitle2" display="block" color={palette.labelColor}>Start this {values.meeting_type} at? *</Typography> </label>
                                            <Typography marginTop="-5px" fontSize="12px" component="em">After this time is reached, users can join to this {values.meeting_type}.</Typography>
                                            <Box>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DateTimePicker
                                                        slotProps={{
                                                            textField: {
                                                                id: "starts_at",
                                                                size: "small",
                                                                color: "secondary"
                                                            }
                                                        }}
                                                        // format='DD-MM-YYYY hh:mm A'
                                                        value={dayjs( values.starts_at )}
                                                        onChange={( e ) => {
                                                            if ( e.isValid() )
                                                                setFieldValue( 'starts_at', e )
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Box>
                                        </FormControl>
                                        <FormControl fullWidth margin='normal' >
                                            <label htmlFor='ends_at' > <Typography gutterBottom variant="subtitle2" display="block" color={palette.labelColor}>End this {values.meeting_type} at? *</Typography> </label>
                                            <Typography marginTop="-5px" fontSize="12px" component="em">After this time is reached, users can not join to this {values.meeting_type}.</Typography>
                                            <Box>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DateTimePicker
                                                        slotProps={{
                                                            textField: {
                                                                id: "ends_at",
                                                                size: "small",
                                                                color: "secondary"
                                                            }
                                                        }}
                                                        // format='DD-MM-YYYY hh:mm A'
                                                        value={dayjs( values.ends_at )}
                                                        onChange={( e ) => {
                                                            if ( e.isValid() )
                                                                setFieldValue( 'ends_at', e )
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Box>
                                        </FormControl>

                                        <FormControl fullWidth margin='normal'>
                                            <Typography gutterBottom variant='subtitle2' color={palette.labelColor}>Please select the meeting type *</Typography>
                                            <RadioGroup
                                                aria-labelledby="meeting_type"
                                                name="meeting_type"
                                                value={values.meeting_type}
                                                onChange={event => handleMeetingTypeChange( event.target.value, setFieldValue )}
                                                sx={{
                                                    margin: 0,
                                                    display: "grid",
                                                    gap: "10px",
                                                    gridTemplateColumns: { md: "auto auto", xs: "1fr" }
                                                }}
                                            >
                                                {meetingTypes.map( meetingType => (
                                                    <FormControlLabel sx={{ margin: 0, border: border[1], borderColor: values.meeting_type === meetingType.value && palette.secondary.main, borderRadius: "5px", padding: "10px", gap: "10px", alignItems: "flex-start" }} key={meetingType.label} value={meetingType.value} control={<Radio color="secondary" />} label={
                                                        <Box flexGrow={1}>
                                                            <Typography fontSize="14px" variant='subtitle2'>{meetingType.label}</Typography>
                                                            <Typography fontSize="10px">{meetingType.description}</Typography>
                                                        </Box>
                                                    } />
                                                ) )}
                                            </RadioGroup>
                                        </FormControl>
                                    </Box>}

                                    {/* SECOND STEP */}
                                    {activeStep === 1 && <Box>
                                        <Box padding="20px">
                                            <Box sx={{ cursor: "pointer" }} padding=" 5px 10px 10px 10px" borderRadius="5px" onClick={e => handleAccessTypeChange( 'ANY_ONE_CAN_JOIN', setFieldValue )} border={border[1]} display="flex" alignItems="flex-start" gap="10px">
                                                <Checkbox size='small' checked={values.meeting_settings.any_one_can_join_with_pass_key} />
                                                <Box marginTop="5px">
                                                    <Typography fontSize="16px" fontWeight={600}>Anyone can join</Typography>
                                                    <Typography fontSize="12px">
                                                        Any person who has access to the meeting link and the meeting passkey can be joined in. Meeting link and the passkey will be generated once the meeting is scheduled.<br />
                                                        (Note: The user has to be let in by one of the hosts to join.)
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box marginTop="5px" padding=" 5px 10px 10px 10px" borderRadius="5px" border={border[1]} sx={{ borderColor: errors?.meeting_settings?.access_type ? palette.error.main : "" }} >
                                                <Box sx={{ cursor: "pointer" }} onClick={e => handleAccessTypeChange( 'SPECIFIED_GROUPS_AND_USERS', setFieldValue )} display="flex" alignItems="flex-start" gap="10px">
                                                    <Checkbox size='small' checked={!values.meeting_settings.any_one_can_join_with_pass_key} />
                                                    <Box flexGrow={1} marginTop="5px">
                                                        <Typography fontSize="16px" fontWeight={600}>Specify student groups or add participants</Typography>
                                                        <Typography fontSize="12px">
                                                            Provide meeting access to selectedd student groups or/and to users by specifying the users' E-mail and name.<br />
                                                        </Typography>
                                                    </Box>
                                                    {!values.meeting_settings?.any_one_can_join_with_pass_key && <IconButton onClick={e => {
                                                        e.stopPropagation()
                                                        setIsUserOrGroupSelectionCollapsed( prev => !prev )
                                                    }}>
                                                        {isUserOrGroupSelectionCollapsed ? Icons.default.KeyboardArrowUp : Icons.default.KeyboardArrowDownIcon}
                                                    </IconButton>}
                                                </Box>
                                                <Collapse in={!values.meeting_settings?.any_one_can_join_with_pass_key && isUserOrGroupSelectionCollapsed}>
                                                    {isLoadingAcYearsBatchesAndSectionsData && <Box height="100px" display="flex" alignItems="center" justifyContent="center">
                                                        <DataLoadingSpinner size={20} waitingMessage={`Loading academic years, batches and sections. please wait...`} />
                                                    </Box>}
                                                    {!values.meeting_settings?.any_one_can_join_with_pass_key && !isLoadingAcYearsBatchesAndSectionsData && !UserStore.getErrorsStatuses?.academicYearsAndBatches && <Box padding="20px" >
                                                        <Box overflow="clip" border={border[1]} borderRadius="5px">
                                                            <Box gap="10px" bgcolor={palette.contentBg} borderBottom={border[1]} display="flex">
                                                                <Button onClick={event => setAcademicYearsAnchorEl( event.currentTarget )} color="greyed" sx={{ borderRadius: "0", borderRight: border[1], cursor: "pointer", padding: "10px 5px 10px 10px", display: "flex", alignItems: "center", gap: "15px" }} >
                                                                    <Typography fontSize="14px">
                                                                        {UserStore.getUserAcademicYears.find( ay => ay.ac_year_id === values.selectedAcYear )?.ac_year}
                                                                    </Typography>
                                                                    {Icons.default.DropDown}
                                                                </Button>
                                                                <Menu
                                                                    anchorEl={academicYearsAnchorEl}
                                                                    open={Boolean( academicYearsAnchorEl )}
                                                                    onClose={() => setAcademicYearsAnchorEl( null )}
                                                                >
                                                                    {UserStore.getUserAcademicYears.map( ( acYear ) => (
                                                                        <MenuItem sx={{ fontSize: "14px" }} onClick={() => setFieldValue( 'selectedAcYear', acYear.ac_year_id )} key={acYear.ac_year_id} selected={acYear.ac_year_id === values.selectedAcYear}>
                                                                            {acYear.ac_year}
                                                                        </MenuItem> )
                                                                    )}
                                                                </Menu>
                                                                <TextField
                                                                    id="group-search"
                                                                    variant='standard'
                                                                    sx={{ flexGrow: 1 }}
                                                                    slotProps={{
                                                                        input: {
                                                                            disableUnderline: true,
                                                                            sx: { background: "none", height: "100%" }
                                                                        }
                                                                    }} placeholder='Search groups' />
                                                            </Box>
                                                            <Box maxHeight="200px" overflow="auto">
                                                                {UserStore.getUsersAllBatchesAndSectionList?.filter( item => item.batch_assignment_id && +item.ac_year_id === +values.selectedAcYear )?.map( ( batch, k ) => {
                                                                    return ( <MenuItem onClick={() => toggleStudentGroupSelection( batch, setFieldValue, values )} sx={{ display: "flex", gap: "5px", alignItems: "center", fontSize: "14px", padding: "0" }} dense key={batch.batch_assignment_id} value={batch.batch_assignment_id}>
                                                                        <Checkbox size='small' checked={Boolean( values.selected_student_groups.find( b => b.id === batch.id ) )} />  <Typography padding="2px 5px" fontSize="10px" borderRadius="5px" bgcolor={palette.primary.dark} color={palette.primary.contrastText} component="span">BATCH</Typography>  {batch.title}
                                                                    </MenuItem> )
                                                                } )}
                                                                {UserStore.getUsersAllBatchesAndSectionList?.filter( item => item.section_assignment_id && +item.ac_year_id === +values.selectedAcYear )?.map( ( section, k ) => {
                                                                    return ( <MenuItem onClick={() => toggleStudentGroupSelection( section, setFieldValue, values )} sx={{ display: "flex", gap: "5px", alignItems: "center", fontSize: "14px", padding: "0px" }} dense key={section.section_assignment_id} value={section.id}>
                                                                        <Checkbox size='small' checked={Boolean( values.selected_student_groups.find( s => s.id === section.id ) )} />  <Typography padding="2px 5px" fontSize="10px" borderRadius="5px" bgcolor={palette.secondary.dark} color={palette.secondary.contrastText} component="span">SECTION</Typography> {section.title}
                                                                    </MenuItem> )
                                                                } )}
                                                            </Box>
                                                        </Box>
                                                        <Typography color='GrayText' fontSize="12px" component="em" >
                                                            {values.section_groups_selected > 0 ? values.section_groups_selected > 1 ? `${values.section_groups_selected} sections selected ` : `1 section selected ` : ""}
                                                            {values.batch_groups_selected > 0 ? values.batch_groups_selected > 1 ? `${values.batch_groups_selected} batches selected` : `1 batch selected` : ""}
                                                        </Typography>
                                                        <Box minHeight="250px" display="flex" flexDirection="column" overflow="clip" marginTop="20px">
                                                            <Box border={border[1]} flexShrink={0} bgcolor={palette.contentBg} borderRadius="5px" display="flex" gap="10px">
                                                                <TextField
                                                                    id='user-search'
                                                                    sx={{ flexGrow: 1 }}
                                                                    variant='standard'
                                                                    slotProps={{
                                                                        input: {
                                                                            disableUnderline: true,
                                                                            sx: { background: "none", height: "40px", paddingLeft: "15px" }
                                                                        }
                                                                    }}
                                                                    value={userSearchValue}
                                                                    onChange={handleUserAddInputChange}
                                                                    onKeyDown={e => handleHostSearchKeyDown( e, setFieldValue, values )}
                                                                    placeholder='Type comma seperated Acharya E-mail to fetch user details  ...' />
                                                            </Box>
                                                            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" padding="5px">
                                                                <Typography color="GrayText" fontSize="12px">OR ADD MANUALLY</Typography>
                                                                <Typography color="GrayText" marginTop="-2px" component="em" display="block" fontSize="10px">Use this method, if data is not fetched from the E-mail</Typography>
                                                            </Box>
                                                            <Box display="flex" flexWrap="wrap" gap="10px" >
                                                                <Box flexGrow={1} border={border[1]} flexShrink={0} bgcolor={palette.contentBg} borderRadius="5px" display="flex" gap="10px">
                                                                    <TextField id="user-name" inputRef={nameInputRef} sx={{ flexGrow: 1 }} variant='standard' slotProps={{ input: { disableUnderline: true, sx: { background: "none", height: "40px", paddingLeft: "15px" } } }} placeholder='Name' />
                                                                </Box>
                                                                <Box flexGrow={1} border={border[1]} flexShrink={0} bgcolor={palette.contentBg} borderRadius="5px" display="flex" gap="10px">
                                                                    <TextField id='user-email' inputRef={emailInputRef} sx={{ flexGrow: 1 }} variant='standard' slotProps={{ input: { disableUnderline: true, sx: { background: "none", height: "40px", paddingLeft: "15px" } } }} placeholder='Acharya E-mail' />
                                                                </Box>
                                                                <Button onClick={() => addNewUser( values, setFieldValue )} variant='outlined' sx={{ borderRadius: "20px" }} startIcon={Icons.default.AddIcon}>
                                                                    Add
                                                                </Button>
                                                            </Box>
                                                            <Box id="drop-container" position="relative" tabIndex={0} onDragOver={handleUserlistFileDragOver} onDragLeave={handleUserlistFileDragLeave} >
                                                                {/* DROPPING OVERLAY */}
                                                                {isDropping && <Box position="absolute" borderRadius="5px" display="flex" onDrop={e => handleUserlistFileDrop( e, values, setFieldValue )} flexDirection="column" alignItems="center" border={border[1]} justifyContent="center" zIndex={10} sx={{ inset: 0, background: palette.background.paper + "ee", borderStyle: "dashed" }} >
                                                                    <Typography sx={{ pointerEvents: "none" }} textAlign="center" fontSize="24px" className='animate-shake' fontWeight={800} ><em>Drop the users list here...</em></Typography>
                                                                </Box>}
                                                                {values.added_users.length === 0 && <Box border={border[1]} alignItems="center" justifyContent="center" flexGrow={1} gap="20px" padding="20px" display="flex" flexDirection="column" sx={{ borderStyle: "dashed", borderRadius: "20px", marginTop: "10px" }} >
                                                                    <Box component="img" src={spreadSheetImg} alt="SpreadSheet" width="120px" />
                                                                    <Typography textAlign="center" fontWeight={300} fontSize="14px"  >Type the users' <Typography fontSize="inherit" color={palette.secondary.main} component="em" fontWeight={600} size='small' >name</Typography> and <Typography fontSize="inherit" color={palette.secondary.main} component="em" fontWeight={600} size='small' >E-mails</Typography> and press <Typography fontSize="inherit" color={palette.secondary.main} component="em" fontWeight={600} size='small'>Add</Typography> button or choose a excel sheet with users name and email in the first two columns respectively in the first page.</Typography>
                                                                    <Typography textAlign="center" fontWeight={500} fontSize="14px"  > Drag and Drop Excel file here or Browse </Typography>
                                                                    <Button tabIndex={-1} component="label" variant='contained' color='secondary' disableElevation sx={{ borderRadius: "20px" }} >
                                                                        Select file
                                                                        <VisuallyHiddenInput accept='.xlsx' type="file" onChange={( e ) => handleOnExcelFileSelection( e, values, setFieldValue )} />
                                                                    </Button>
                                                                </Box>}
                                                                {values.added_users.length > 0 && <Box flexGrow={1} marginTop="10px" overflow="clip" borderRadius="5px" border={border[1]} display="flex" flexDirection="column">
                                                                    <TableContainer sx={{ height: "100%", maxHeight: "300px" }}>
                                                                        <Table stickyHeader>
                                                                            <TableHeader columns={userTableColumns} />
                                                                            <TableBody>
                                                                                {values.added_users?.map( ( user, index ) => (
                                                                                    <TableRow className='table-row' key={index}>
                                                                                        <TableCell align='center' sx={{ padding: "5px" }} >
                                                                                            {index + 1}
                                                                                        </TableCell>
                                                                                        <TableCell align='center' sx={{ padding: "5px" }} >
                                                                                            <Checkbox checked={user.host} onChange={() => toggleHostAccess( user, values, setFieldValue )} />
                                                                                        </TableCell>
                                                                                        <TableCell sx={{ padding: "5px" }} >
                                                                                            <em>{user.user_name}</em>
                                                                                        </TableCell>
                                                                                        <TableCell sx={{ padding: "5px" }} >
                                                                                            <em>{user.user_email}</em>
                                                                                        </TableCell>
                                                                                        <TableCell align="right" sx={{ padding: "5px 20px" }} >
                                                                                            <IconButton onClick={() => removeAddedUser( index, values, setFieldValue )} color='error' size="small">
                                                                                                <Delete sx={{ fontSize: "18px" }} />
                                                                                            </IconButton>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                ) )}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </Box>}
                                                            </Box>
                                                            <Typography marginTop="5px" color='GrayText' fontSize="12px" component="em" >
                                                                {values.added_users.length > 0 ? values.added_users.length > 1 ? `${values.added_users.length} users selected ` : `1 user selected ` : ""}
                                                            </Typography>
                                                        </Box>
                                                    </Box>}
                                                </Collapse>
                                            </Box>
                                        </Box>
                                        <Box marginTop="20px">
                                            <Box padding="10px 20px" borderTop={border[1]} borderBottom={border[1]}>
                                                <label htmlFor="title"><Typography variant='subtitle2' fontSize="14px" component="h3" gutterBottom letterSpacing="1px" textTransform="uppercase" >Participants Management</Typography></label>
                                                <Typography marginTop="-5px" fontSize="12px" display="block" component="em">Control what participants can do inside the meeting. Please note that these will only be applied to participants other than hosts. Host will have complete access regardless of the below settings.</Typography>
                                            </Box>
                                            {/* {values.meeting_settings.any_one_can_join_with_pass_key && <Box marginTop="5px" padding="0 20px">
                                                <Box sx={{ cursor: "pointer" }}>
                                                    <Box flexGrow={1} display="flex" alignItems="center" marginTop="5px">
                                                        <Checkbox color="primary" size='small' sx={{ transform: `scale(0.9)` }} checked={values.meeting_settings.enable_open_joins} onChange={e => setFieldValue( 'meeting_settings.enable_open_joins', e.target.checked )} />
                                                        <Typography fontSize="16px" fontWeight={600}>Open join</Typography>
                                                    </Box>
                                                    <Typography marginLeft="12px" marginTop="-5px" fontSize="12px">
                                                        No one has to ask to join the meeting. any one can join without permission.
                                                    </Typography>
                                                </Box>
                                            </Box>} */}
                                            <Box marginTop="5px" padding="0 20px">
                                                <Box>
                                                    <Box flexGrow={1} display="flex" alignItems="center" marginTop="5px">
                                                        <Checkbox color="primary" size='small' sx={{ transform: `scale(0.9)` }} checked={values.meeting_settings.join_without_host} onChange={e => setFieldValue( 'meeting_settings.join_without_host', e.target.checked )} />
                                                        <Typography fontSize="16px" fontWeight={500}>Join without host</Typography>
                                                    </Box>
                                                    <Typography marginLeft="12px" color="textSecondary" marginTop="-5px" fontSize="12px">
                                                        Participants can join and converse without the present of host.
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box marginTop="5px" padding="0 20px">
                                                <Box>
                                                    <Box flexGrow={1} display="flex" alignItems="center" marginTop="5px">
                                                        <Checkbox color="primary" size='small' sx={{ transform: `scale(0.9)` }} checked={values.meeting_settings.enable_reactions} onChange={e => setFieldValue( 'meeting_settings.enable_reactions', e.target.checked )} />
                                                        <Typography fontSize="16px" fontWeight={500}>Send reactions</Typography>
                                                    </Box>
                                                    <Typography marginLeft="12px" color="textSecondary" marginTop="-5px" fontSize="12px">
                                                        Participants can express their emotions through emojis.
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box marginTop="5px" padding="0 20px">
                                                <Box>
                                                    <Box display="flex" alignItems="center" flexGrow={1} marginTop="5px">
                                                        <Checkbox color="primary" size='small' sx={{ transform: `scale(0.9)` }} checked={values.meeting_settings.enable_chats} onChange={e => setFieldValue( 'meeting_settings.enable_chats', e.target.checked )} />
                                                        <Typography fontSize="16px" fontWeight={500}>Send messages</Typography>
                                                    </Box>
                                                    <Typography marginLeft="12px" color="textSecondary" marginTop="-5px" fontSize="12px">
                                                        Participants can send chat messages to meeting chat and private messages to hosts.
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box marginTop="5px" padding="0 20px">
                                                <Box gap="10px">
                                                    <Box flexGrow={1} display="flex" alignItems="center" marginTop="5px">
                                                        <Checkbox disabled={values.meeting_type === 'webinar'} color="primary" size='small' sx={{ transform: `scale(0.9)` }} checked={values.meeting_settings.enable_microphone} onChange={e => setFieldValue( 'meeting_settings.enable_microphone', e.target.checked )} />
                                                        <Typography fontSize="16px" fontWeight={500}>Turn on microphone</Typography>
                                                    </Box>
                                                    <Typography marginLeft="12px" color="textSecondary" marginTop="-5px" fontSize="12px" >
                                                        Participants can turn on microphone to send their audio.
                                                    </Typography>
                                                    {values.meeting_type === 'webinar' && <Typography component="em" fontSize="12px" marginLeft="10px" marginTop="-1px" display="block" color="warning"> Cannot be enabled in webinar mode! </Typography>}
                                                </Box>
                                            </Box>
                                            <Box marginTop="5px" padding="0 20px">
                                                <Box gap="10px">
                                                    <Box display="flex" alignItems="center" flexGrow={1} marginTop="5px">
                                                        <Checkbox disabled={values.meeting_type === 'webinar'} color="primary" size='small' sx={{ transform: `scale(0.9)` }} checked={values.meeting_settings.enable_video_feed} onChange={e => setFieldValue( 'meeting_settings.enable_video_feed', e.target.checked )} />
                                                        <Typography fontSize="16px" fontWeight={500}>Turn on video</Typography>
                                                    </Box>
                                                    <Typography marginLeft="12px" color="textSecondary" marginTop="-5px" fontSize="12px">
                                                        Participants can turn on video to send their video feed.
                                                    </Typography>
                                                    {values.meeting_type === 'webinar' && <Typography component="em" fontSize="12px" marginLeft="10px" marginTop="-1px" display="block" color="warning"> Cannot be enabled in webinar mode! </Typography>}
                                                </Box>
                                            </Box>
                                            <Box marginTop="5px" padding="0 20px">
                                                <Box>
                                                    <Box flexGrow={1} display="flex" alignItems="center" marginTop="5px">
                                                        <Checkbox disabled={values.meeting_type === 'webinar'} color="primary" size='small' sx={{ transform: `scale(0.9)` }} checked={values.meeting_settings.enable_screen_sharing} onChange={e => setFieldValue( 'meeting_settings.enable_screen_sharing', e.target.checked )} />
                                                        <Typography fontSize="16px" fontWeight={500}>Share screen</Typography>
                                                    </Box>
                                                    <Typography marginLeft="12px" color="textSecondary" marginTop="-5px" fontSize="12px">
                                                        Participants can share their screen to the meeeting.
                                                    </Typography>
                                                    {values.meeting_type === 'webinar' && <Typography component="em" fontSize="12px" marginLeft="10px" marginTop="-1px" display="block" color="warning"> Cannot be enabled in webinar mode! </Typography>}
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>}
                                    {( ( errors.title && touched.title ) || ( errors.ends_at && touched.ends_at ) || ( errors.starts_at && touched.starts_at ) || ( errors.meeting_settings && touched.meeting_settings ) ) && <Box padding="20px"  >
                                        {<Box padding="10px" borderRadius="5px" bgcolor={palette.error.main + "22"} border={`2px solid ${palette.error.dark}`}>
                                            <Typography fontSize="12px" fontWeight={500} color="error.dark"  ><ErrorMessage name='title' /></Typography>
                                            <Typography fontSize="12px" fontWeight={500} color="error.dark"  ><ErrorMessage name='starts_at' /></Typography>
                                            <Typography fontSize="12px" fontWeight={500} color="error.dark"  ><ErrorMessage name='ends_at' /></Typography>
                                            <Typography fontSize="12px" fontWeight={500} color="error.dark"  >{errors?.meeting_settings?.access_type || ""}</Typography>
                                        </Box>}
                                    </Box>}

                                    <Box display="flex" gap="10px" padding="20px" flexWrap="wrap" alignItems="center" justifyContent="flex-end" marginTop="20px">
                                        {[1, 2].includes( activeStep ) && <Button disableElevation variant='contained' disabled={creatingMeeting} startIcon={Icons.default.KeyBoardArrowLeft} onClick={handleBack} size='large'>{activeStep === 2 ? "Configure access" : "Meeting details"}</Button>}
                                        {activeStep === 0 && <Button disableElevation variant='contained' endIcon={Icons.default.KeyBoardArrowRight} onClick={() => validateFirstStep( validateForm, setFieldTouched )} size='large'>Configure access</Button>}
                                        {activeStep === 1 && <Button disableElevation variant='contained' disabled={creatingMeeting} type='submit' startIcon={creatingMeeting ? <CircularProgress size={20} /> : Icons.default.CheckIcon} size='large'>Create Meeting</Button>}
                                        <Button disableElevation variant='outlined' color="error" disabled={creatingMeeting} size='large' onClick={() => handleClose( resetForm )}>Cancel</Button>
                                    </Box>
                                </Form>
                            </Box>
                        )
                    }}
                </Formik>}

            {
                newRoom && <MeetingDetailsCopyDialog meeting={newRoom} open={Boolean( newRoom )} handleClose={handleClose} setOpen={setOpen} />}
        </Dialog >
    )
} )

export default CreateRoom